export default "__VITE_ASSET__0bb24e9e__"